import { Directive, ElementRef, Input, OnInit, Optional, Renderer2, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

import { toBoolean, NzSizeLDSType } from 'ant-reset-private/core';

@Directive({
  selector: '[nz-input]',
  exportAs: 'nzInput',
  host: {
    '[class.ant-input-disabled]': 'nzDisabled || disabled',
    '[class.ant-input-lg]': `nzSize === 'large'`,
    '[class.ant-input-sm]': `nzSize === 'small'`
  }
})
export class NzInputDirective implements OnInit {
  private _disabled = false;
  @Input() nzSize: NzSizeLDSType = 'default';

  @Input()
  set nzDisabled(value: boolean) {
    this._disabled = toBoolean(value);
    this.readonlySwitch();
  }

  get nzDisabled(): boolean {
    if (this.ngControl && this.ngControl.disabled) {
      return this.ngControl.disabled;
    }
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = toBoolean(value);
    this.readonlySwitch();
  }

  get disabled(): boolean {
    if (this.ngControl && this.ngControl.disabled) {
      return this.ngControl.disabled;
    }
    return this._disabled;
  }

  readonlySwitch(): void {
    if (this._disabled) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'readonly', 'true');
    } else {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'readonly');
    }
  }

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    public renderer: Renderer2,
    public elementRef: ElementRef
  ) {
    renderer.addClass(elementRef.nativeElement, 'ant-input');
  }

  ngOnInit(): void {
  }

}
